export const TestIds = {
    root: 'linkElement',
};
//# sourceMappingURL=constants.js.map